var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-details',{attrs:{"id":_vm.$router.currentRoute.params.orgId,"display-invite":false,"can-change-group":true,"display-org-flags":true}})}
var staticRenderFns = []

export { render, staticRenderFns }